/**
 * Stem / kind field aliases for a twin-test follow-up (why).
 *
 * LEGACY PARSE ONLY. Twin-test no longer arms or edits paired OE on the wire
 * (Wave 1). `gateArtifacts.readQuestion` still recognizes leftover stems so an
 * old approved body does not crash the gate card; the UI does not surface or
 * re-emit them. Spend, unit counting, and add/remove-follow-up paths are gone.
 *
 * Mirrors backend `TWIN_TEST_FOLLOW_UP_STEM_KEYS` /
 * `TWIN_TEST_FOLLOW_UP_KIND_KEYS` in `twin-test-spec.mapper.ts` for the names
 * that may still appear on historical artifacts.
 */

/** Writer-declared stem keys (canonical first, then snake_case / legacy). */
const GATE_FOLLOW_UP_STEM_KEYS: ReadonlyArray<string> = [
  'followUpStem',
  'follow_up_stem',
  'pairedOeStem',
  'paired_oe_stem',
]

/** Pairing kind keys (camelCase + snake_case). */
const GATE_FOLLOW_UP_KIND_KEYS: ReadonlyArray<string> = [
  'pairedOe',
  'paired_oe',
]

function readNonEmptyString(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null
  }
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

/** First non-empty stem across the alias list, or null. */
export function readFollowUpStem(entry: Record<string, unknown>): string | null {
  for (const key of GATE_FOLLOW_UP_STEM_KEYS) {
    const stem = readNonEmptyString(entry[key])
    if (stem) {
      return stem
    }
  }
  return null
}

/** First non-empty pairing kind across the alias list, or null. */
export function readFollowUpKind(entry: Record<string, unknown>): string | null {
  for (const key of GATE_FOLLOW_UP_KIND_KEYS) {
    const kind = readNonEmptyString(entry[key])
    if (kind) {
      return kind
    }
  }
  return null
}

